import React from 'react';

export const LoginNotFound = () => (
  <div className="flex items-center justify-center w-screen h-screen">
    <div className="px-10 py-16 border border-gray-200 rounded-md shadow-lg bg-gray-50">
      <h1 className="mb-3 text-xl font-bold">Login Page Not Found</h1>
      <p>We were unable to find your login page. Please check the spelling and try again.</p>
      <p>
				You can reach us at{' '}
        <a
          href="https://support.oncolens.com"
          className="font-semibold text-blue-800 underline"
          rel="noreferrer"
          target="_blank"
        >
					support.oncolens.com
        </a>{' '}
				for additional help.
      </p>
    </div>
  </div>
);
